import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PredikatKinerja from 'app/KinerjaPSPage/pages/PredikatKinerja'
import PageGuardPengawas from 'app/KinerjaPSPage/components/PageGuardPengawas'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-ps-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = () => (
  <PageGuardPengawas>
    <PredikatKinerja />
  </PageGuardPengawas>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
  printablePage: true,
  pageTitle: 'Penetapan Predikat Kinerja',
}

export default Page
